var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"dashboard-widget-preview",style:(_vm.previewStyle),attrs:{"src":_vm.previewSrc,"alt":"","aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }